import type { ReactElement } from 'react'

/**
 * Props for {@link MessageVariableList}.
 *
 * @property variables - The variable names a message template can read, in display order.
 * @property title - The list's heading, also its accessible region name.
 * @property hint - Optional help text under the heading.
 */
export interface MessageVariableListProps {
	variables: readonly string[]
	title: string
	hint?: string
}

/**
 * The variables a notification message can use, each shown as the Liquid
 * expression to type (`{{ customer.full_name }}`) — TO-140. Pure.
 */
export function MessageVariableList({ variables, title, hint }: MessageVariableListProps): ReactElement {
	return (
		<section aria-label={title} className="flex flex-col gap-2">
			<h3 className="text-ds-sm font-semibold text-ds-text">{title}</h3>
			{hint ? <p className="text-ds-xs text-ds-text-muted">{hint}</p> : null}
			<ul className="flex flex-wrap gap-2">
				{variables.map((name) => (
					<li key={name}>
						<code className="rounded-ds-sm bg-ds-surface-muted px-2 py-1 text-ds-xs text-ds-text">{`{{ ${name} }}`}</code>
					</li>
				))}
			</ul>
		</section>
	)
}
